import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext({
  locale: '',
  setLocale: () => { },
});

export const useLanguage = () => useContext(LanguageContext);

// Supported languages
export const SUPPORTED_LANGUAGES = ['de', 'en'] //, 'it', 'fr', 'es', 'pl', 'cs', 'pt'];

export const LanguageProvider = ({ children }) => {
  // Determine the initial language
  const browserLanguage = navigator.language.split('-')[0]; // Extract language code
  const initialLanguage = SUPPORTED_LANGUAGES.includes(browserLanguage) ? browserLanguage : 'de';

  const [locale, setLocale] = useState(initialLanguage);

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
};